import { useState } from 'react'
import { Link } from 'react-router-dom';
import { useScrollPosition } from '../../hooks/useScrollPosition';
import { HeadLinksI } from '../../utilities/links';
import Button from '../Widgets/Button';
import CalendlyButton from '../Widgets/CalendlyButton';
import CustomLink from '../Widgets/ScrollLink';
import smartaLogo from "../../assets/smarta.png"


type NavbarI = {
	filled?: boolean, // if there should be a background color by default
	links?: HeadLinksI // links that should be on the nav
}

const Navbar = ({ filled, links = [] }: NavbarI) => {
	const [showNav, setShowNav] = useState(false);
	// const [isDark, setIsDark] = useState(localStorage.theme === 'dark');
	// const changeTheme = () => {
	// 	if (localStorage.theme === 'light') {
	// 		setIsDark(true);
	// 		document.documentElement.classList.add('dark')
	// 		localStorage.theme = 'dark'
	// 	} else {
	// 		setIsDark(false);
	// 		document.documentElement.classList.remove('dark')
	// 		localStorage.theme = 'light';
	// 	}
	// }
	const scrollPosition = useScrollPosition()
	const afterNavIsBlur = (e: React.FocusEvent) => {
		if (!e.currentTarget.contains(e.relatedTarget)) {
			setShowNav(false)
		}
	}
	return (
		<>
			<nav onBlur={afterNavIsBlur} tabIndex={-1} className={`text-slate-700 dark:text-white outline-none backdrop-blur-sm transition-all duration-500 flex shadow flex-col lg:flex-row lg:items-center app-x fixed inset-x-0 z-10 ${(scrollPosition < 170 && !showNav && !filled) ? 'bg-transparent dark:bg-transparent shadow-none text-white' : 'dark:bg-slate-900/90 bg-[#fffffff1]'}`}>
				<div className='flex justify-between items-center h-[4.5rem]'>
					<Link to="/" className='font-serif flex space-x-2 items-center text-lg font-extrabold brand'>
						<img src={smartaLogo} className="w-8 rm-drag" alt="logo" />
						<span>SMARTA</span>
					</Link>
					<button className='focused lg:hidden' onClick={() => setShowNav(!showNav)}>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
							<path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
						</svg>
					</button>
				</div>
				<div className={`${!showNav && '-translate-y-[150%] lg:translate-y-0 fixed lg:static lg:z-0'} transition-all duration-300 pb-5 lg:pb-0 lg:ml-auto lg:items-center flex flex-col lg:flex-row overflowed max-h-[80vh]`}>
					<ul className={`pb-5 ${(scrollPosition < 170 && !filled) ? 'lg:text-white' : 'lg:text-slate-700'} text-slate-600 dark:text-white flex flex-col lg:flex-row lg:space-x-6 lg:pb-0 font-serif text-xs xl:text-[.8rem] font-medium`}>
						{links.map(({ text, to, scrollOn }, i) => (
							<li key={i} className={`hover:text-primary truncate transition`}>
								<CustomLink to={to} scrollOn={scrollOn}>
									<button onClick={() => setShowNav(false)} className='focused rounded py-2 lg:py-3 w-full text-left uppercase'>
										{text}
									</button>
								</CustomLink>
							</li>
						))}
						{/* <li>
						</li> */}
					</ul>
					<CalendlyButton className="lg:ml-8">
						<Button text='Get Started' primary />
					</CalendlyButton>
					{/* <button className='hover:bg-[#00000046] transition rounded-full h-8 w-8 flex justify-center items-center mt-3 lg:mt-0 lg:ml-3' onClick={changeTheme}>
						<i className={`bx bx-${isDark ? 'sun' : 'moon'}`} ></i>
					</button> */}
				</div>
			</nav>
		</>
	)
}

export default Navbar